export default class JustifyPersist {
  justificationId: string;

  observation: string;

  competenceStart: string;

  competenceEnd: string;

  revertAllFromContractGroup: boolean;

  constructor(obj: any) {
    this.justificationId = obj.justificationId || '';
    this.observation = obj.observation || '';
    this.competenceStart = obj.competenceStart || '';
    this.competenceEnd = obj.competenceEnd || '';
    this.revertAllFromContractGroup = obj.revertAllFromContractGroup || false;
  }

  public static of(obj: any): JustifyPersist {
    return new JustifyPersist(obj || {});
  }

  public static ofList(obj: any = []): JustifyPersist[] {
    return obj.map(this.of);
  }
}
